import { type IAvailabilityBlock } from "@/interfaces/api/availability-block.interface.ts"
import { BaseRepository } from "@/repositories/base-repository"

export class AvailabilityBlockRepository extends BaseRepository<IAvailabilityBlock> {
  resourcePath = "core/availability-blocks"
}
